import React from "react";
import { useDispatch } from "react-redux";
import { IoCloseOutline } from "react-icons/io5";
import DraggablePad from "../Dialpad/DraggablePad";
import { closeModal } from "../../features/modal/ModalSlice";

const DialpadPopUp = () => {
  const dispatch = useDispatch();

  const handleClosePopup = () => {
    dispatch(closeModal());
  };

  return (
    <div className={"rightModal taskModal"}>
      <div className="modal-header p-3">
        <h4 className="m-0">Call</h4>
        <button className="btnClose ms-auto" onClick={handleClosePopup}>
          <IoCloseOutline />
        </button>
      </div>

      <div className="p-4">
        {/* <form className="row">
          <div className="col-12">
            <div className="row">
              <div className="col-12">
                <select className="form-select cstSelect" name="assigned_to">
                  <option value={""}># select Extension Number</option>
                </select>
              </div>
              <div className="col-12 mt-5">
                <select className="form-select cstSelect" name="assigned_to">
                  <option value={""}># User</option>
                </select>
              </div>
              <div className="bottomBtn mt-3">
                <div className="d-flex gap-4 justify-content-end">
                  <button className="btnNobg py-2">Cancel</button>

                  <button
                    className="btnSubmit py-2"
                    onClick={() => {
                      handleClosePopup();
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form> */}
        <DraggablePad />
      </div>
    </div>
  );
};

export default DialpadPopUp;
